import { motion } from "framer-motion";
import { MANIFESTO, STATS } from "../lib/site";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] } }),
};

export const Manifesto = () => {
  return (
    <section id="about" data-testid="manifesto-section" className="relative py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-center gap-3 mb-16">
          <span className="overline text-[#B87333]">/ Our Manifesto</span>
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="font-serif text-[clamp(2rem,5vw,4.5rem)] leading-[1.02] tracking-[-0.02em] max-w-4xl mb-20"
        >
          Trusted partner to builders who <span className="italic text-[#B87333]">refuse</span> to compromise.
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.n}
              variants={reveal}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              className={`py-10 md:py-4 md:px-10 ${i !== 0 ? "border-t md:border-t-0 md:border-l border-white/10" : "md:pr-10"}`}
            >
              <span className="font-serif text-6xl text-[#B87333]/30">{m.n}</span>
              <h3 className="font-grotesk text-xl md:text-2xl font-bold mt-6 mb-4 text-[#F5F5F0]">{m.title}</h3>
              <p className="font-body text-[#8A8A82] leading-relaxed">{m.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 mt-24 border border-white/10">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-[#070707] p-8 md:p-12"
            >
              <div className="font-serif text-4xl md:text-6xl text-[#F5F5F0] tracking-tight">{s.value}</div>
              <div className="overline text-[#8A8A82] mt-3">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
